<template>
  <div class="main-container">
    <h3>最近浏览记录</h3>
    <div class="list">
      <van-row>
        <van-col span="13">试题编号</van-col>
        <van-col span="11">浏览时间</van-col>
      </van-row>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :error.sync="error" error-text="请求失败，点击重新加载" :finished="finished"
          finished-text="没有更多了" @load="getData">
          <van-collapse v-model="collapseName" accordion>
            <van-collapse-item v-for="(item, index) in list" :key="index" :name="index">
              <template #title>
                <van-col span="12">{{ item.qid }}</van-col>
                <van-col span="12">{{ item.dateline | formatDate }}</van-col>
              </template>
              <van-cell-group>
                <van-cell title="URL" :value="item.title">
                  <template #title>
                    <a :href="item.url" target="_blank">{{ item.url }}</a>
                  </template>
                </van-cell>
                <van-cell title="IP" :value="item.ip" />
                <van-cell title="地址" :value="item.city" />
              </van-cell-group>
            </van-collapse-item>
          </van-collapse>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import {
  DateUtil
} from '@/utils/date.js'
import { List, PullRefresh, Collapse, CollapseItem } from 'vant'
export default {
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  data() {
    return {
      list: [],
      error: false,
      loading: false,
      finished: false,
      refreshing: false,
      total: 9999999,
      collapseName: 'mycollapse'
    }
  },
  methods: {
    getData() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      const params = {
        pagesize: 10,
        page: 0
      }
      if (this.list.length >= this.total) {
        this.finished = true
        return false
      }
      params.page = Math.ceil(this.list.length / params.pagesize) + 1
      this.$api.user.gethistory(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.list = this.list.concat(res.data.data.data)
            this.total = res.data.data.total
            this.loading = false
          } else {
            this.$notify(res.data.message)
            this.error = true
          }
        })
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.getData()
    }
  },
  filters: {
    formatDate: function (time) {
      if (time !== null && time !== '') {
        var date = new Date(time * 1000)
        return DateUtil.formatDateTime(date, 'yyyy-MM-dd H:m:s')
      } else {
        return ''
      }
    },
    logintype: function (type) {
      let typestr = ''
      switch (type) {
        case 1:
          typestr = '手机号登陆'
          break
        case 2:
          typestr = '用户名登录'
          break
        case 3:
          typestr = 'app登录'
          break
        default:
          typestr = '手机号登陆'
      }
      return typestr
    }
  }
}
</script>
<style scoped="scoped" lang="less">
.list {
  font-size: 16px;

  .van-row {
    padding: 5px 20px;
    border-bottom: 1px solid #dcdcdc;
  }

  .van-col {
    line-height: 28px;
  }
}
</style>
